import React, { Component } from "react";
import { connect } from 'react-redux';
import { View, Text, TouchableOpacity, ScrollView, Switch, StyleSheet, Image } from 'react-native'

import { phoneNumberFormate, openLink } from "../../../functions";
import Header from "../../../components/Header";
import { ProfileAvatar } from "../../../components";
import styles from "../../../styles";
import { global, colors } from "../../../const";
import { logoutUser, getUserPersonalDetails, updateWeSwitch } from "../../../action";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faTimes, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { placeholder, lock_ic_dark, icon_email, icon_Language, icon_Logout, icon_PrivacyPolicy, icon_Support, icon_TEL, icon_UseTerms, icon_WE } from '../../../assets'
import LogoutDialog from "../../../components/modal/LogoutDialog";
import { PrimaryTitle, LinkIndigo } from "../../../components/labels";
import SettingItem from "../../../components/List/SettingItem";
import localize from "../../../localize";


class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            logoutModal: false,
            userInfo: props.userInfo,
            sEnableEnglish: false,
        }
    }

    componentDidMount() {
        const { phone_number, email } = this.props.userInfo;
        if (!phone_number || !email)
            this.props.getUserPersonalDetails();
    }

    _navigate = (pathname, state) => {
        return this.props.history.push({
            pathname,
            state
        })
    };

    onLogout = () => {
        this.props.logoutUser();
        if (window.wsConnection) window.wsConnection.close(3000);
        this.setState({ logoutModal: false });
        this.props.history.push("/SignIn");
    }

    _navigateUrl = (url) => {
        return openLink(url)
    }

    render() {
        const { logoutModal, userInfo } = this.state;
        const { avatar, phone_number, email, nickname } = userInfo;
        const { app_language, app } = this.props;

        return (
            <View style={styles.container}>
                <Header title={localize.settings} right={(
                    <TouchableOpacity
                        onPress={() => this.props.history.goBack()}
                        style={{ padding: 10 }}
                    >
                        <Icon
                            icon={faTimes}
                            color={colors.white}
                            style={{ position: "static", fontSize: 24 }}
                        />
                    </TouchableOpacity>
                )
                } />
                <ScrollView style={{ height: this.props.height - 70 }}>

                    <View style={[styles.titleBox, { justifyContent: 'center' }]}>
                        <PrimaryTitle size={15} weight="bold" align="center">
                            {localize.personal_information}
                        </PrimaryTitle>
                    </View>

                    <View>
                        <View style={{ flexDirection: 'row', padding: 10, alignItems: 'center' }}>
                            <View style={pageStyles.avatar}>
                                <ProfileAvatar src={avatar ? { uri: global.MAKEURL(avatar) } : placeholder} />
                            </View>

                            <View style={{ marginLeft: 20 }}>
                                <PrimaryTitle size={15}>
                                    {localize.user_name}
                                </PrimaryTitle>
                                <Text style={pageStyles.listSubTitle}>{`(${nickname})`}</Text>
                                <TouchableOpacity
                                    onPress={() => this._navigate("profile")}
                                    activeOpacity={0.6}>
                                    <LinkIndigo>
                                        {localize.view_profile}
                                    </LinkIndigo>
                                </TouchableOpacity>
                            </View>
                        </View>
                        <View style={pageStyles.divider} />
                        <SettingItem
                            title={localize.password}
                            subtitle="******"
                            avatar={lock_ic_dark}
                            onPress={() => this._navigate("settings/password-reset")}
                            right={<Icon icon={faChevronRight} color={colors.midnightBack} style={{ position: "static" }} />}
                        />
                        <SettingItem
                            title={localize.phone_number}
                            subtitle={phoneNumberFormate((phone_number || ""))}
                            onPress={() => this._navigate("settings/change-phone")}
                            right={<Icon icon={faChevronRight} color={colors.midnightBack} style={{ position: "static" }} />}
                            icon={icon_TEL}
                        />
                        <SettingItem
                            title={localize.email_address}
                            subtitle={email}
                            onPress={() => this._navigate("settings/change-email")}
                            right={<Icon icon={faChevronRight} color={colors.midnightBack} style={{ position: "static" }} />}
                            icon={icon_email}
                        />
                        <SettingItem
                            title={localize.Language}
                            subtitle={app_language === "eng" ? "English" : "中文"}
                            onPress={() => this._navigate("/settings/languages")}
                            right={<Icon icon={faChevronRight} color={colors.midnightBack} style={{ position: "static" }} />}
                            icon={icon_Language}
                        />
                        {/* {
                            app === "dv" && (
                                <SettingItem
                                    title={localize.Woogi_English}
                                    subtitle={localize.Show_woogi_english_statistics}
                                    activeOpacity={1}
                                    icon={icon_WE}
                                    right={
                                        <Switch
                                            value={this.props.isEnableEnglish}
                                            onValueChange={(val) => this.props.updateWeSwitch(val)}
                                        />
                                    }
                                />
                            )
                        } */}

                    </View>
                    <View style={[styles.titleBox, { justifyContent: 'center' }]}>
                        <PrimaryTitle size={15} weight="bold" align="center">
                            {localize.MORE_INFORMATION}
                        </PrimaryTitle>
                    </View>
                    <View>
                        <TouchableOpacity
                            style={pageStyles.supportList}
                            activeOpacity={0.8}
                            onPress={() => this._navigateUrl(global.supportUrl)}>
                            <Image
                                source={icon_Support}
                                style={pageStyles.info_ic}
                            />
                            <View style={pageStyles.info_title}>
                                <LinkIndigo>
                                    {localize.SUPPORT}
                                </LinkIndigo>
                            </View>
                        </TouchableOpacity>

                        <View style={pageStyles.divider} />

                        <TouchableOpacity
                            style={pageStyles.supportList}
                            activeOpacity={0.8}
                            onPress={() => this._navigateUrl(global.privacyUrl)}
                        >
                            <Image
                                source={icon_PrivacyPolicy}
                                style={pageStyles.info_ic}
                            />
                            <View style={pageStyles.info_title}>
                                <LinkIndigo>
                                    {localize.PRIVACY_POLICY}
                                </LinkIndigo>
                            </View>
                        </TouchableOpacity>
                        <View style={pageStyles.divider} />
                        <TouchableOpacity
                            style={pageStyles.supportList}
                            activeOpacity={0.8}
                            onPress={() => this._navigateUrl(global.termUrl)}
                        >
                            <Image
                                source={icon_UseTerms}
                                style={pageStyles.info_ic}
                            />
                            <View style={pageStyles.info_title}>
                                <LinkIndigo>
                                    {localize.TERMS_OF_USE}
                                </LinkIndigo>
                            </View>
                        </TouchableOpacity>
                        <View style={pageStyles.divider} />

                        <TouchableOpacity
                            style={pageStyles.supportList}
                            activeOpacity={0.8}
                            onPress={() => this.setState({ logoutModal: true })}>
                            <Image
                                source={icon_Logout}
                                style={pageStyles.info_ic}
                            />
                            <View style={pageStyles.info_title}>
                                <LinkIndigo>
                                    {localize.LOGOUT}
                                </LinkIndigo>
                            </View>
                        </TouchableOpacity>
                        <View style={pageStyles.divider} />
                    </View>
                </ScrollView>
                <LogoutDialog
                    isVisible={logoutModal}
                    onLogout={this.onLogout}
                    onCancel={() => this.setState({ logoutModal: false })}
                />
            </View >
        )
    }
}

const mapStateToProps = ({ setting, auth }) => {
    return {
        height: setting.height,
        userInfo: auth.userInfo,
        isEnableEnglish: setting.isEnableEnglish,
        app_language: setting.app_language

    }
}
const mapDispatch = (dispatch) => {
    return {
        logoutUser: () => dispatch(logoutUser()),
        getUserPersonalDetails: () => dispatch(getUserPersonalDetails()),
        updateWeSwitch: (val) => dispatch(updateWeSwitch(val))
    }
}
export default connect(mapStateToProps, mapDispatch)(Settings);

const pageStyles = StyleSheet.create({
    divider: {
        height: 1,
        backgroundColor: colors.lightGray,
        width: '100%'
    },
    settingList: {
        flexDirection: 'row',
        padding: 10,
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    rowCenter: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    avatar: {
        width: 55,
        height: 55,
        marginLeft: 10
    },
    listSubTitle: {
        color: colors.midnightBack,
        fontFamily: global.FONT_REGULAR,
        fontSize: 14
    },
    supportList: {
        justifyContent: "center",
        alignItems: "center",
        padding: 15,
        flexDirection: "row"
    },
    info_ic: {
        height: 22, width: 22, resizeMode: "contain", marginRight: 10
    },
    info_title: {
        width: 120,
        justifyContent: "center",
        alignItems: "center",
    },
})
